import React, { useCallback, useEffect, useState } from "react";
import visitorCard from "../../assets/image/general_visitor_card_bg.jpg";
import trader_member from "../../assets/image/trader_member_card_bg.jpg";
import trader from "../../assets/image/trader_card_bg.jpg";
import nri from "../../assets/image/nri_card_bg.jpg";
import media from "../../assets/image/media_card_bg.jpg";
import axios from "axios";
import html2canvas from "html2canvas";
import { QRCodeCanvas } from "qrcode.react";
import { useSearchParams } from "react-router-dom";

const Ebadge = () => {
  const [image, setImage] = useState("");
  const [name, setName] = useState("");
  const [city, setCity] = useState("");
  const [visitorType, setVisitorType] = useState(""); 
  const [company_name, setCompanyName] = useState("");
  const [background, setBackground] = useState(visitorCard);
  const [loader, setLoader] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [searchParams] = useSearchParams();

  const barcode = searchParams.get("v");

  // 🔥 Correct role → label + background mapping
  const assignCardDetails = (roleFromAPI) => {
    const role = roleFromAPI?.toLowerCase();

    switch (role) {
      case "visitor":
        setVisitorType("VISITOR");
        setBackground(visitorCard);
        break;

      case "trader":
        setVisitorType("TRADE VISITOR");
        setBackground(trader);
        break;

      case "trade_member":
        setVisitorType("TRADE MEMBER");
        setBackground(trader_member);
        break;

      case "nri":
        setVisitorType("NRI");
        setBackground(nri);
        break;

      case "media":
        setVisitorType("MEDIA");
        setBackground(media);
        break;

      default:
        setVisitorType("VISITOR");
        setBackground(visitorCard);
    }
  };

  // Fetch API
  useEffect(() => {
    const formData = new FormData();
    formData.append("barcode", barcode);

    axios
      .post(`${process.env.REACT_APP_API_END_POINT}/verify-barcode`, formData)
      .then((resData) => {
        const { visitor_name, city, visiting_as, barcode, company_name } =
          resData.data.visitor[0];

        setImage(resData.data?.photo_base64);
        setName(visitor_name);
        setCity(city);
        setInputValue(barcode);
        setCompanyName(company_name);
        assignCardDetails(visiting_as); // 🔥 clean role logic
      })
      .catch((err) => console.log("Barcode error:", err.message));
  }, [barcode]);

  // Screenshot Handler
  const handleScreenshot = useCallback(() => {
    const body = document.getElementById("printable-content");
    setLoader(true);

    html2canvas(body, { useCORS: true, scale: 2 }).then((canvas) => {
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = "badge.png";
      link.click();
      setLoader(false);
    });
  }, []);

  return (
    <section>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          id="printable-content"
          style={{
            width: "430px",
            height: "700px",
            position: "relative",
            backgroundImage: `url(${background})`,
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          {/* Visitor Photo */}
          <img
            src={image}
            alt=""
            style={{
              position: "absolute",
              top: "250px",
              left: "50%",
              transform: "translateX(-50%)",
              height: "130px",
              width: "120px",
              objectFit: "cover",
              borderRadius: "10px",
              border: "2px solid #000",
            }}
          />

          {/* Visitor Details */}
          <div
            style={{
              position: "absolute",
              top: "400px",
              width: "100%",
              textAlign: "center",
            }}
          >
            <h3 style={{ fontSize: "16px", marginBottom: "6px" }}>{name}</h3>
            <h4 style={{ fontSize: "13px", marginBottom: "6px" }}>
              {company_name}
            </h4>
            <h4 style={{ fontSize: "13px", marginBottom: "10px" }}>{city}</h4>

            <QRCodeCanvas value={inputValue} size={85} />
            <div style={{ marginTop: "5px", fontSize: "12px" }}>
              {inputValue}
            </div>

            <h2
              style={{
                marginTop: "20px",
                fontWeight: "bold",
                fontSize: "26px",
              }}
            >
              {visitorType}
            </h2>
          </div>
        </div>
      </div>

      {/* Screenshot Button */}
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <button className="btn btn-dark" onClick={handleScreenshot}>
          {loader ? "Processing..." : "Take Screenshot"}
        </button>
      </div>
    </section>
  );
};

export default Ebadge;
